import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js'
import { Line } from 'react-chartjs-2'
import { EmptyState } from '../EmptyState'
import clsx, { ClassValue } from 'clsx'
import { LoadingState } from '../LoadingState'
import { ErrorState } from '../ErrorState'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
)

export type LineChartProps = {
  title?: string
  legend?: {
    position: 'top' | 'bottom' | 'right' | 'left'
  }
  data?: {
    labels?: string[]
    datasets?: {
      label: string
      data: number[]
      backgroundColor: string
      borderColor: string
      stacked?: string
    }[]
  }
  loading?: boolean
  error?: boolean
  className?: ClassValue
}

export function LineChart (props: LineChartProps) {
  const { legend, title, data, loading, error, className } = props

  const labels = data?.labels
  const datasets = data?.datasets

  const isEmpty = !datasets || datasets.flatMap(item => item.data).length === 0

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: legend || { display: false },
      title: {
        display: !!title,
        text: title
      }
    },
    scales: {
      x: {
        grid: {
          color: 'transparent'
        }
      },
      y: {
        min: 0
      }
    }
  }

  return (
    <>
      {error && <ErrorState />}
      {loading && <LoadingState />}
      {isEmpty && !error && !loading && <EmptyState />}
      {!error && !loading && !isEmpty && datasets && labels && (
        <div className={clsx('h-full', isEmpty && 'hidden', className)}>
          <Line
            options={options}
            data={{
              datasets,
              labels
            }}
          />
        </div>)}
    </>
  )
}
